import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReduxProvider } from './ReduxProvider';
import { AuthInitializer } from './AuthInitializer';

interface AppProvidersProps {
  children: React.ReactNode;
}

const GOOGLE_CLIENT_ID = '541716939925-ftsktgf5culju42gl1qt96qvh39tf2p4.apps.googleusercontent.com';

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <GoogleOAuthProvider
      clientId={GOOGLE_CLIENT_ID || ''}
      onScriptLoadError={() => console.error('Google OAuth script load error')}
      onScriptLoadSuccess={() => console.log('Google OAuth script loaded')}
    >
      <ReduxProvider>
        <AuthInitializer>
          {children}
        </AuthInitializer>
      </ReduxProvider>
    </GoogleOAuthProvider>
  );
};